// Imports
import { MenuBookOutlined } from '@mui/icons-material';
import { Fab, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Fragment, useEffect, useState } from 'react';
import { GobikesApi } from '../../config/Apis';
import { parseErrorForAxios } from '../utils/CommonUtils';
import { getAuthCookie } from '../auth/AuthUtil';
import { Colors, DEFAULT_LOADER_STYLES } from '../../config/Constants';
import { LedgerTable } from './LedgerTable';
import { LedgerModel } from '../utils/Models';
import { DashboardLoader } from '../utils/LocalStateUtils';
import { setNavSelection } from '../../features/navSelection';
import { useDispatch } from 'react-redux';

// Types and constants
interface LocalState {
  loading?: boolean;
  error?: boolean;
  message?: string;
}

// Main app component
export function Ledger(props: {
  window?: () => Window;
  drawerWidth: number
}) {
  // Local state
  const [state, setState] = useState<LocalState>({});
  const [ledgerData, setLedgerData] = useState<{ ledger: LedgerModel[], balance: number }>({ ledger: [], balance: 0 });
  const dispatch = useDispatch();

  // Set nav state
  useEffect(() => {
    dispatch(setNavSelection(7));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Load ledger on first load
  useEffect(() => {
    const authCookie = getAuthCookie();
    if (!authCookie) return;
    setState({ loading: true });
    (async () => {
      try {
        const { data } = await GobikesApi.get(`/vendors/ledger`, { headers: { 'vendor-token': authCookie } })
        setState({});
        setLedgerData(data.data);
      } catch (e) {
        setState({ error: true, message: parseErrorForAxios(e) });
      }
    })();
  }, []);

  // Loading view
  let mainContent = <div></div>;
  if (state.loading) {
    mainContent = <DashboardLoader
      {...state}
      styles={DEFAULT_LOADER_STYLES}
    />
  }

  // Error view
  else if (state.error) {
    mainContent = <DashboardLoader
      {...state}
      styles={DEFAULT_LOADER_STYLES}
    />
  }

  // Default view
  else {
    mainContent = <Fragment>
      <Box className='gbk-tabs' sx={{ typography: 'body1', m: '30px 0 0 0' }}>
        <LedgerTable
          ledger={ledgerData.ledger}
          setParentState={setState}
          containerClass={'gbk-grid-parent no-fabs'}
        />
      </Box >
    </Fragment>
  }

  // Return DOM
  return (
    <Box sx={{ mt: { xs: '50px', md: 0 }, ml: { xs: 0, md: `${props.drawerWidth}px` }, width: { xs: '100%', md: `calc(100% - ${props.drawerWidth}px)` }, height: '100%' }}>
      <div className='gbk-tabcontent'>

        {/* Balance */}
        <Fab
          className='gbk-fab gbk-fab-top-right gbk-fab-info'
          sx={{ display: { xs: 'none', md: 'inline-flex' }, color: Colors.primary, borderColor: Colors.primary }}
          variant='extended' >
          Current Balance: ₹ {ledgerData.balance.toFixed(2)}
        </Fab>

        {/* Header */}
        <Box className='tab-header' sx={{ display: { xs: 'none', md: 'block' } }}>

          {/* Icon */}
          <div className={`tab-header-fab`} >
            <MenuBookOutlined fontSize="large" />
          </div>

          {/* Text */}
          <Typography>
            Payments
          </Typography>
        </Box>

        {/* Main content */}
        {mainContent}

      </div >
    </Box >
  )

}